import { useRef } from "react";

/**
 * The last non-zero `dataUpdatedAt`, dropped whenever `resetKey` changes.
 *
 * The freshness chip needs stickiness because a shifted rolling window mints a
 * fresh query key that reports `dataUpdatedAt: 0` until its first response —
 * without it the timestamp blinks out every five minutes. But switching the
 * ACTIVE MACHINE mints a fresh key the same way, and there the old value is not
 * merely stale, it belongs to a different machine: the header asserted
 * "Live · HH:mm:ss" for a machine whose data had not arrived, using the previous
 * machine's landing time. Pass the machine as `resetKey` and the badge says
 * nothing until this machine's own data lands.
 */
export const useStickyUpdatedAt = (dataUpdatedAt: number, resetKey: string): number => {
  const lastRef = useRef(0);
  const keyRef = useRef(resetKey);
  if (keyRef.current !== resetKey) {
    keyRef.current = resetKey;
    lastRef.current = 0;
  }
  if (dataUpdatedAt > 0) lastRef.current = dataUpdatedAt;
  return lastRef.current;
};
